module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/library-d1f16724166b7d5b99ff7879b8416c21.svg";